import { useState } from 'react'
import { DialogModal } from '../../../../../components/DialogModal'

type BioModalProps = {
  expertBioText: string
}

export const BioModal = ({ expertBioText }: BioModalProps) => {
  const [openDialogModal, setDialogModalOpen] = useState(false)

  const openOrCloseDialogModal = (value: boolean) => {
    setDialogModalOpen(value)
  }

  return (
    <>
      <button
        className="text-xs font-bold text-primary-light border border-primary-light rounded px-1"
        type="button"
        onClick={() => openOrCloseDialogModal(true)}
      >
        Ver bio
      </button>
      <DialogModal
        isOpen={openDialogModal}
        title="Bio"
        onClose={() => openOrCloseDialogModal(false)}
        styleBox={{ maxWidth: '36rem' }}
      >
        <div className="w-full flex flex-col justify-center items-center pb-10">
          <div className="overflow-auto max-h-96">
            <p className="m-10">
              {expertBioText.split('\n').map((textline, index) => (
                <span key={index}>
                  {textline}
                  <br />
                </span>
              ))}
            </p>
          </div>
          <button
            className="w-40 py-3 my-3 text-base font-bold text-center whitespace-nowrap text-white rounded-lg bg-primary-light"
            type="button"
            onClick={() => openOrCloseDialogModal(false)}
          >
            Fechar
          </button>
        </div>
      </DialogModal>
    </>
  )
}
